import { type FileCategoryBase } from "src/cases/caseView/FileCategory";
import {
  CreateCaseContextStep,
  SourceOption,
} from "src/cases/createCase/CreateCaseContextStep";
import { CreateCasePropertiesStep } from "src/cases/createCase/CreateCasePropertiesStep";
import { CreateCaseRoutingStep } from "src/cases/createCase/CreateCaseRoutingStep";
import { useCurrentCreateCaseStep } from "src/cases/createCase/createCaseSteps";
import { CasePropertiesValue } from "src/clients/case-management";

type CreateCaseFormRouterProps = {
  sourceOptions: SourceOption[] | undefined;
  fileCategories: FileCategoryBase[];
  caseProperties: Record<string, CasePropertiesValue> | undefined;
  statusProperty: CasePropertiesValue | undefined;
  queueId: string;
};

export const CreateCaseFormRouter: React.FC<CreateCaseFormRouterProps> = ({
  sourceOptions,
  fileCategories,
  caseProperties,
  statusProperty,
  queueId,
}) => {
  const [currentStepId] = useCurrentCreateCaseStep();

  switch (currentStepId) {
    case "context":
      return (
        <CreateCaseContextStep
          fileCategories={fileCategories}
          sourceOptions={sourceOptions}
        />
      );
    case "properties":
      return <CreateCasePropertiesStep caseProperties={caseProperties} />;
    case "case-routing":
      return (
        <CreateCaseRoutingStep
          queueId={queueId}
          statusProperty={statusProperty}
        />
      );
  }
};
